/*!
 * JM Language Preview v1.5 — Custom Language necklaces & bracelets.
 * Switched on per product by metafield custom.lang_preview (json):
 *   { "type": "necklace" | "bracelet", "images": "custom-language-{type}-blank-{metal}.jpg", "w": 1500,
 *     "chain": [[x, y], …], "maxNames": 5, "maxLen": 12, "letter": 82 (optional), "slots": (optional) }
 * Per name: language and the name in English. We translate it as they type (the most common spelling) and show
 * it under the box and on the live preview; "Write it myself" lets them type or paste their own spelling instead.
 * Translation: with a Google Cloud Translation key (theme editor → JM Name Preview → key, website-restricted) every
 * language uses Google Translate's spelling; without one we fall back to Google Input Tools (letter by letter, rougher).
 * Order properties: "Name 1", "Name 1 (Arabic)", … "Languages", and "_Name 1 spelling" (auto / customer / to translate).
 * Needs jm-lang-render.js.
 */
(function () {
  'use strict';
  function el(t, c, a) { var n = document.createElement(t); if (c) n.className = c; if (a) Object.keys(a).forEach(function (k) { n.setAttribute(k, a[k]); }); return n; }

  /* ----- spelling suggestions ----- */
  // Google Input Tools (the same suggestions Google's keyboards give) for the languages it covers
  var GIT = { 'Arabic': 'ar', 'Amharic': 'am', 'Bengali': 'bn', 'Farsi (Persian)': 'fa', 'Greek': 'el', 'Gujarati': 'gu', 'Hebrew': 'he',
    'Hindi': 'hi', 'Kannada': 'kn', 'Malayalam': 'ml', 'Punjabi': 'pa', 'Russian': 'ru', 'Tamil': 'ta', 'Telugu': 'te', 'Thai': 'th',
    'Tigrinya': 'ti', 'Ukrainian': 'uk', 'Urdu': 'ur' };
  // simple letter-by-letter spelling for scripts that sound out like English
  var MAP = {
    'Armenian': [['sh', 'շ'], ['ch', 'չ'], ['zh', 'ժ'], ['kh', 'խ'], ['ts', 'ց'], ['th', 'թ'], ['ph', 'ֆ'], ['ou', 'ու'], ['oo', 'ու'], ['ee', 'ի'], ['y', 'յ'],
      ['a', 'ա'], ['b', 'բ'], ['c', 'կ'], ['d', 'դ'], ['e', 'ե'], ['f', 'ֆ'], ['g', 'գ'], ['h', 'հ'], ['i', 'ի'], ['j', 'ջ'], ['k', 'կ'], ['l', 'լ'], ['m', 'մ'],
      ['n', 'ն'], ['o', 'ո'], ['p', 'պ'], ['q', 'ք'], ['r', 'ր'], ['s', 'ս'], ['t', 'տ'], ['u', 'ու'], ['v', 'վ'], ['w', 'վ'], ['x', 'քս'], ['z', 'զ']],
    'Georgian': [['sh', 'შ'], ['ch', 'ჩ'], ['zh', 'ჟ'], ['kh', 'ხ'], ['ts', 'ც'], ['th', 'თ'], ['ph', 'ფ'], ['gh', 'ღ'], ['ee', 'ი'], ['oo', 'უ'],
      ['a', 'ა'], ['b', 'ბ'], ['c', 'კ'], ['d', 'დ'], ['e', 'ე'], ['f', 'ფ'], ['g', 'გ'], ['h', 'ჰ'], ['i', 'ი'], ['j', 'ჯ'], ['k', 'კ'], ['l', 'ლ'], ['m', 'მ'],
      ['n', 'ნ'], ['o', 'ო'], ['p', 'პ'], ['q', 'ქ'], ['r', 'რ'], ['s', 'ს'], ['t', 'ტ'], ['u', 'უ'], ['v', 'ვ'], ['w', 'ვ'], ['x', 'ქს'], ['y', 'ი'], ['z', 'ზ']]
  };
  function mapSpell(lang, s) {
    var m = MAP[lang]; if (!m) return null;
    s = s.toLowerCase().replace(/[^a-z]/g, ''); var out = '', i = 0;
    while (i < s.length) { var hit = null; for (var k = 0; k < m.length; k++) if (s.substr(i, m[k][0].length) === m[k][0]) { hit = m[k]; break; } if (hit) { out += hit[1]; i += hit[0].length; } else i++; }
    if (lang === 'Armenian' && out) { if (s[0] === 'o' && s.substr(0, 2) !== 'ou' && s.substr(0, 2) !== 'oo') out = 'օ' + out.slice(1); else if (s[0] === 'e') out = 'է' + out.slice(1); out = out.charAt(0).toUpperCase() + out.slice(1); }
    return out ? [out] : null;
  }
  // Baybayin: sound the name out in Filipino syllables, then write each syllable (ka, ki, ku, k + krus-kudlit)
  var BB_C = { k: 'ᜃ', g: 'ᜄ', N: 'ᜅ', t: 'ᜆ', d: 'ᜇ', n: 'ᜈ', p: 'ᜉ', b: 'ᜊ', m: 'ᜋ',
    y: 'ᜌ', r: 'ᜇ', l: 'ᜎ', w: 'ᜏ', s: 'ᜐ', h: 'ᜑ' };
  var BB_V = { a: 'ᜀ', i: 'ᜁ', u: 'ᜂ' }, BB_K = { i: 'ᜒ', u: 'ᜓ', x: '᜔' };
  function baybayin(word) {
    var s = String(word).toLowerCase().replace(/[^a-z]/g, ''); if (!s) return null;
    s = s.replace(/c(?=[eiy])/g, 's');
    if (s.length >= 5) s = s.replace(/([aeiouy][^aeiouy])e$/, '$1');
    s = s.replace(/(.)\1+/g, '$1').replace(/ph/g, 'p').replace(/th/g, 't').replace(/sh/g, 'sy').replace(/ch(?=[rl])/g, 'k').replace(/ch/g, 'ts')
      .replace(/gu(?=[ei])/g, 'g').replace(/ng(?![aeiouy])/g, 'N')
      .replace(/qu/g, 'k').replace(/c(?=[eiy])/g, 's').replace(/[cq]/g, 'k').replace(/x/g, 'ks').replace(/j/g, 'dy').replace(/f/g, 'p').replace(/v/g, 'b').replace(/z/g, 's')
      .replace(/e/g, 'i').replace(/o/g, 'u').replace(/(^|[^aiu])y(?![aiu])/g, '$1i')
      .replace(/i(?=[au])/g, 'iy').replace(/u(?=[ai])/g, 'uw');
    var out = '';
    for (var i = 0; i < s.length; i++) {
      var c = s[i];
      if (BB_V[c]) { out += BB_V[c]; continue; }
      if (!BB_C[c]) continue;
      var v = s[i + 1];
      if (v && BB_V[v]) { out += BB_C[c] + (v === 'a' ? '' : BB_K[v]); i++; } else out += BB_C[c] + BB_K.x;
    }
    return out || null;
  }
  // Google Cloud Translation (official, needs JM's key): Google Translate's spelling for every language it covers
  var GTR = { 'Arabic': 'ar', 'Amharic': 'am', 'Armenian': 'hy', 'Bengali': 'bn', 'Farsi (Persian)': 'fa', 'Georgian': 'ka', 'Greek': 'el',
    'Gujarati': 'gu', 'Hebrew': 'iw', 'Hindi': 'hi', 'Japanese (Hiragana)': 'ja', 'Japanese (Katakana)': 'ja', 'Kannada': 'kn', 'Korean': 'ko',
    'Khmer': 'km', 'Malayalam': 'ml', 'Mandarin (Modern)': 'zh-CN', 'Mandarin (Traditional)': 'zh-TW', 'Punjabi': 'pa', 'Russian': 'ru',
    'Tamil': 'ta', 'Telugu': 'te', 'Thai': 'th', 'Tigrinya': 'ti', 'Ukrainian': 'uk', 'Urdu': 'ur' };
  // a name on its own can come back translated by meaning (Grace → "blessing"), so we ask for "Grace Smith",
  // which Google always treats as a person, and take "Smith" off again
  // characters are what Google charges for, so: "Smith" is translated once per language, the name alone only if needed,
  // and every answer is remembered in the browser
  var SUR = {};
  function gCall(lang, qs) {
    return fetch('https://translation.googleapis.com/language/translate/v2?key=' + encodeURIComponent(GKEY) + '&source=en&format=text&target=' + GTR[lang] +
      qs.map(function (q) { return '&q=' + encodeURIComponent(q); }).join(''))
      .then(function (r) { return r.json(); })
      .then(function (j) { return ((j && j.data && j.data.translations) || []).map(function (x) { return String(x.translatedText || '').trim(); }); });
  }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem('jmlp:' + k)); localStorage.setItem('jmlp:' + k, JSON.stringify(v)); } catch (e) { return null; } }
  function gTranslate(lang, word) {
    var saved = store(lang + '|' + word.toLowerCase());
    if (saved && saved.length) return Promise.resolve(saved);
    SUR[lang] = SUR[lang] || store('sur|' + lang);
    var qs = SUR[lang] ? [word + ' Smith'] : [word + ' Smith', 'Smith'];
    return gCall(lang, qs).then(function (t) {
        if (!t.length) return [];
        if (!SUR[lang] && t[1]) { SUR[lang] = t[1]; store('sur|' + lang, t[1]); }
        var full = t[0], sur = SUR[lang] || '', out = '';
        if (sur && full.slice(-sur.length) === sur) out = full.slice(0, -sur.length);
        else if (sur && full.indexOf(sur) === 0) out = full.slice(sur.length);
        else { var parts = full.split(/[\s·・‧]+/); out = parts.length > 1 ? parts.slice(0, -1).join(' ') : full; }
        out = out.replace(/^[\s·・‧\-.,]+|[\s·・‧\-.,]+$/g, '');
        return out ? out : gCall(lang, [word]).then(function (t2) { return (t2[0] || '').replace(/[.。]$/, ''); });
      }).then(function (out) {
        if (!out || !out.length) return [];
        if (/[぀-ヿ一-鿿]/.test(out)) out = out.replace(/[\s・·]/g, '');
        var res = [lang === 'Japanese (Hiragana)' ? kataToHira(out) : out];
        store(lang + '|' + word.toLowerCase(), res);
        return res;
      }, function () { return []; });
  }
  var GKEY = '';
  function kataToHira(s) { return s.replace(/[ァ-ヶ]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0x60); }); }
  var cache = {};
  function suggest(lang, word) {
    word = String(word || '').trim(); if (!word) return Promise.resolve([]);
    var key = lang + '|' + word.toLowerCase(); if (cache[key]) return cache[key];
    var p;
    if (lang === 'Baybayin (Filipino)') p = Promise.resolve([baybayin(word)].filter(Boolean));
    else if (GKEY && GTR[lang] && /^[a-z\s'-]+$/i.test(word)) p = gTranslate(lang, word.charAt(0).toUpperCase() + word.slice(1));
    else if (lang === 'Japanese (Kanji)' && /^[a-z\s'-]+$/i.test(word)) {
      // Japanese names typed in romaji (Sakura, Yuki, Hana) → the kanji Google's Japanese keyboard offers first; other names → we write them
      p = fetch('https://inputtools.google.com/request?text=' + encodeURIComponent(word.toLowerCase().replace(/[\s'-]/g, '')) + '&itc=ja-t-i0-und&num=8&cp=0&cs=1&ie=utf-8&oe=utf-8')
        .then(function (r) { return r.json(); })
        .then(function (j) { var c = j[0] === 'SUCCESS' && j[1] && j[1][0] ? (j[1][0][1] || []) : []; return c.filter(function (k) { return /^[一-鿿々]+$/.test(k); }).slice(0, 1); }, function () { return []; });
    }
    else if (MAP[lang]) p = Promise.resolve(mapSpell(lang, word) || []);
    else if (GIT[lang] && /^[a-z\s'-]+$/i.test(word)) {
      p = fetch('https://inputtools.google.com/request?text=' + encodeURIComponent(word.toLowerCase()) + '&itc=' + GIT[lang] + '-t-i0-und&num=4&cp=0&cs=1&ie=utf-8&oe=utf-8')
        .then(function (r) { return r.json(); })
        .then(function (j) { return j[0] === 'SUCCESS' && j[1] && j[1][0] ? (j[1][0][1] || []).slice(0, 4) : []; }, function () { return []; });
    } else p = Promise.resolve([]);
    cache[key] = p; return p;
  }
  function canSuggest(lang) { return lang === 'Baybayin (Filipino)' || lang === 'Japanese (Kanji)' || !!(GKEY ? GTR[lang] : (MAP[lang] || GIT[lang])); }
  function isLatin(s) { return /^[\sA-Za-z'\-.]*$/.test(s); }

  function start() {
    var cfgEl = document.querySelector('script[data-jmlp-config]');
    if (!cfgEl || window.__jmlp || !window.JMLangRender) return;
    var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    window.__jmlp = true;
    var cfg = C.cfg || {}, R = window.JMLangRender, LANGS = Object.keys(R.languages);
    GKEY = C.gkey || cfg.gkey || '';
    // per-product font choices from the metafield, e.g. "fonts": { "English": ["Pinyon Script", 400] }
    if (cfg.fonts) Object.keys(cfg.fonts).forEach(function (l) { var f = cfg.fonts[l], cur = R.languages[l]; if (cur && f) { cur[0] = f[0] || cur[0]; cur[1] = f[1] || cur[1]; if (f[2]) cur[3] = f[2]; } });
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (f) { return f.querySelector('[name="id"]') && !/installment/i.test(f.className) && !f.closest('shopify-payment-terms'); });
    var form = forms.filter(function (f) { return !/sticky/i.test((f.parentElement && f.parentElement.className) || ''); })[0] || forms[0];
    if (!form) return;

    /* ----- options ----- */
    function optIndex(re) { var o = C.options || []; for (var i = 0; i < o.length; i++) if (re.test(String(o[i]))) return i; return -1; }
    var iMetal = optIndex(/colou?r|metal|material|finish/i), iCount = optIndex(/number of names|names/i), iLang = optIndex(/language/i);
    var words = { one: 1, two: 2, three: 3, four: 4, five: 5 };
    function countOf(v) { var m = String(v).match(/\d+/); if (m) return +m[0]; var w = String(v).toLowerCase().match(/[a-z]+/g) || []; for (var i = 0; i < w.length; i++) if (words[w[i]]) return words[w[i]]; return 1; }
    function metalOf(v) { v = String(v).toLowerCase(); return /rose/.test(v) ? 'rose' : /silver|925|sterling|white/.test(v) ? 'silver' : 'gold'; }
    function variant() { var id = (form.querySelector('[name="id"]') || {}).value; return (C.variants || []).filter(function (v) { return String(v.id) === String(id); })[0]; }
    function picked(name) {
      var nm = 'options[' + name + ']', els = document.querySelectorAll('select, input[type="radio"]:checked'), val = null;
      Array.prototype.forEach.call(els, function (e) {
        if (val !== null || box.contains(e)) return;
        if (e.name === nm || (e.type === 'radio' && e.name.replace(/-\d+$/, '') === name)) { if (e.offsetParent !== null || !val) val = e.value; }
      });
      return val;
    }
    function current() {
      var v = variant();
      if (!v) { var o = (C.options || []).map(function (n) { return picked(n); }); if (o.every(function (x) { return x !== null; })) v = { options: o }; }
      // ?jmnames=3 in the address lets JM try 1–5 names on the test theme before the Number of Names option exists
      var test = +((location.search.match(/[?&]jmnames=(\d)/) || [])[1] || 0);
      return { n: Math.max(1, Math.min(cfg.maxNames || 5, test || (v && iCount >= 0 ? countOf(v.options[iCount]) : 1))),
        metal: v && iMetal >= 0 ? metalOf(v.options[iMetal]) : 'gold',
        lang: v && iLang >= 0 ? matchLang(v.options[iLang]) : matchLang(cfg.lang || 'English') };
    }
    function matchLang(s) { s = String(s || ''); return LANGS.indexOf(s) >= 0 ? s : (LANGS.filter(function (l) { return s.toLowerCase().indexOf(l.split(' ')[0].toLowerCase()) === 0; })[0] || 'English'); }

    /* ----- the name boxes ----- */
    var css = el('style'); css.textContent = [
      '.jmlp{display:grid;gap:1.1em;margin:0 0 1.25em}',
      '.jmlp__name{display:grid;gap:.45em;padding:.9em;border:1px solid rgba(0,0,0,.1);border-radius:12px;background:#fff}',
      '.jmlp__name[hidden]{display:none}',
      '.jmlp__head{display:flex;gap:.6em;align-items:center;justify-content:space-between}',
      '.jmlp__t{font-size:.75em;letter-spacing:.12em;text-transform:uppercase;opacity:.75;margin:0}',
      '.jmlp__sel{height:38px;border:1px solid rgba(0,0,0,.2);border-radius:999px;padding:0 .9em;background:#fff;font:inherit;font-size:.85em;max-width:60%}',
      '.jmlp__in{height:46px;padding:0 1em;font:inherit;border:1px solid rgba(0,0,0,.2);border-radius:10px;background:#fff;width:100%;box-sizing:border-box}',
      '.jmlp__in.invalid{border-color:#c0392b;box-shadow:0 0 0 3px rgba(192,57,43,.15)}',
      '.jmlp__in--script{font-size:1.15em}',
      '.jmlp__h{font-size:.78em;opacity:.65;margin:0}',
      '.jmlp__sel{cursor:pointer}',
      '.jmlp__out{display:flex;flex-wrap:wrap;align-items:baseline;justify-content:space-between;gap:.3em .8em;padding:.55em .8em;border-radius:10px;background:#f6f5f3}',
      '.jmlp__out[hidden]{display:none}',
      '.jmlp__res{font-size:.85em;opacity:.8;margin:0;min-height:1.4em}',
      '.jmlp__res b{font-size:1.45em;font-weight:600;opacity:1;color:#1a1a1a;unicode-bidi:isolate}',
      '.jmlp__own{border:0;background:none;padding:0;font:inherit;font-size:.8em;text-decoration:underline;cursor:pointer;color:inherit;opacity:.75}',
      '.jmlp__in--script[hidden]{display:none}'
    ].join(''); document.head.appendChild(css);

    var box = el('div', 'jmlp', { 'data-jmlp': '' });
    var anchor = form.querySelector('.product-form__buttons') || form.querySelector('[type="submit"]');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor); else form.insertBefore(box, form.firstChild);
    var MAXN = cfg.maxNames || 5, maxLen = cfg.maxLen || 12, rows = [];
    for (var i = 0; i < MAXN; i++) rows.push(makeRow(i));
    function makeRow(i) {
      var r = { i: i, picked: '' };
      r.wrap = el('div', 'jmlp__name');
      var head = el('div', 'jmlp__head'), t = el('p', 'jmlp__t'); t.textContent = 'Name ' + (i + 1);
      r.sel = el('select', 'jmlp__sel', { 'aria-label': 'Language for name ' + (i + 1) });
      LANGS.forEach(function (l) { var o = el('option'); o.value = o.textContent = l; r.sel.appendChild(o); });
      head.appendChild(t); head.appendChild(r.sel); r.wrap.appendChild(head);
      r.en = el('input', 'jmlp__in', { type: 'text', autocomplete: 'off', maxlength: String(maxLen), placeholder: 'Name in English (e.g. Sophia)' });
      r.wrap.appendChild(r.en);
      // the translation, shown under the name as they type
      r.out = el('div', 'jmlp__out'); r.res = el('p', 'jmlp__res', { 'aria-live': 'polite' });
      r.own = el('button', 'jmlp__own', { type: 'button' });
      r.out.appendChild(r.res); r.out.appendChild(r.own); r.wrap.appendChild(r.out);
      r.sc = el('input', 'jmlp__in jmlp__in--script', { type: 'text', autocomplete: 'off', maxlength: '24', dir: 'auto' });
      r.wrap.appendChild(r.sc);
      r.hint = el('p', 'jmlp__h'); r.wrap.appendChild(r.hint);
      // what goes on the order
      r.pEn = el('input', '', { type: 'hidden', name: 'properties[Name ' + (i + 1) + ']' });
      r.pSc = el('input', '', { type: 'hidden' });
      r.pHow = el('input', '', { type: 'hidden', name: 'properties[_Name ' + (i + 1) + ' spelling]' });
      r.wrap.appendChild(r.pEn); r.wrap.appendChild(r.pSc); r.wrap.appendChild(r.pHow);
      var t0 = null;
      r.en.addEventListener('input', function () { r.en.classList.remove('invalid'); clearTimeout(t0); t0 = setTimeout(function () { refreshSuggest(r); }, GKEY ? 450 : 200); soon(); });
      r.sc.addEventListener('input', function () { r.sc.classList.remove('invalid'); showRes(r); sync(); soon(); });
      r.own.addEventListener('click', function () {
        r.chose = !r.mine;
        labels(r);
        if (r.mine) { if (!r.sc.value) r.sc.value = r.auto || ''; labels(r); r.sc.focus(); } else { r.sc.value = r.auto || ''; labels(r); }
        sync(); soon();
      });
      r.sel.addEventListener('change', function () {
        r.langTouched = true; newLang(r);
        if (i === 0) { setProductLang(r.sel.value); r.langTouched = false; layout(); }
        refreshSuggest(r); soon();
      });
      box.appendChild(r.wrap);
      return r;
    }
    function lang(r) { return r.sel.value; }
    function short(L) { return L.replace(/ \((Filipino|Persian|Modern)\)/, ''); }
    function labels(r) {
      var L = lang(r), auto = canSuggest(L), eng = L === 'English';
      r.mine = !eng && (!!r.chose || !auto);
      r.sc.placeholder = 'Type or paste it in ' + short(L);
      r.sc.hidden = eng || !r.mine;
      r.out.hidden = eng || (!auto && !r.en.value.trim());
      r.own.hidden = !auto;
      r.own.textContent = r.mine ? 'Use our translation' : 'Write it myself';
      r.hint.textContent = eng ? '' : !auto ? 'Type or paste your name in ' + short(L) + ' if you have it. If not, leave it blank and we’ll translate it for you before it’s made.'
        : r.mine ? 'This exact spelling will be cut.' : '';
      r.hint.hidden = !r.hint.textContent;
      showRes(r);
      r.pSc.name = eng ? '' : 'properties[Name ' + (r.i + 1) + ' (' + L + ')]';
    }
    function showRes(r) {
      var L = lang(r), w = r.en.value.trim();
      r.res.textContent = '';
      if (L === 'English' || !w) { r.res.textContent = canSuggest(L) ? 'Type a name to see it in ' + short(L) : ''; return; }
      var txt = r.mine ? r.sc.value.trim() : r.auto;
      if (!canSuggest(L) && !txt) { r.res.textContent = 'We’ll translate “' + w + '” into ' + short(L) + ' for you'; return; }
      if (!txt) { r.res.textContent = r.busy ? 'Translating…' : 'We’ll translate “' + w + '” for you'; return; }
      r.res.appendChild(document.createTextNode(w + ' in ' + short(L) + ': '));
      var b = el('b', '', { dir: 'auto' }); b.textContent = txt; r.res.appendChild(b);
    }
    // name 1's language is the product's Languages option, so changing one changes the other
    function setProductLang(L) {
      if (iLang < 0) return;
      var nm = 'options[' + C.options[iLang] + ']', done = false;
      Array.prototype.forEach.call(document.querySelectorAll('select'), function (s) {
        if (box.contains(s) || (s.name !== nm && !/variant|option/i.test(s.name + s.className))) return;
        var o = Array.prototype.filter.call(s.options, function (o) { return matchLang(o.value) === L && (o.value === L || o.value.indexOf(L.split(' ')[0]) === 0); })[0];
        if (!o || s.value === o.value) return;
        s.value = o.value;
        if (!done && s.offsetParent !== null) { done = true; s.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      if (!done) Array.prototype.forEach.call(document.querySelectorAll('input[type="radio"]'), function (x) {
        if (!done && !box.contains(x) && x.value === L && x.offsetParent !== null && !x.checked) { done = true; x.click(); }
      });
    }
    function newLang(r) { r.chose = false; r.auto = ''; r.sc.value = ''; }
    // the top (most common) spelling is used straight away: no list to choose from
    function refreshSuggest(r) {
      var L = lang(r), word = r.en.value.trim(), my = r.tok = (r.tok || 0) + 1;
      r.auto = ''; r.busy = false;
      if (!r.mine) r.sc.value = '';
      if (L === 'English' || !word || !isLatin(word) || !canSuggest(L)) { labels(r); sync(); return; }
      r.busy = true; labels(r);
      suggest(L, word).then(function (list) {
        if (my !== r.tok) return;
        r.busy = false; r.auto = list[0] || '';
        if (!r.mine) r.sc.value = r.auto;
        labels(r); sync(); soon();
      });
    }
    function sync() {
      rows.forEach(function (r) {
        var on = !r.wrap.hidden, L = lang(r), sc = L === 'English' ? '' : r.sc.value.trim();
        r.pEn.disabled = r.pHow.disabled = !on;
        r.pEn.value = r.en.value.trim();
        r.pSc.value = sc; r.pSc.disabled = !on || !sc;
        r.pHow.value = L === 'English' ? 'as typed' : !sc ? 'please translate' : r.mine ? 'written by customer' : lang(r) === 'Baybayin (Filipino)' ? 'our Baybayin converter' : GKEY ? 'Google Translate' : 'Google Input Tools';
        if (L === 'English') r.pHow.disabled = true;
      });
      if (pLangs) {
        var st = current(), ls = rows.slice(0, st.n).map(function (r) { return lang(r); });
        pLangs.value = ls.join(', '); pLangs.disabled = st.n < 2;
      }
    }

    var pLangs = el('input', '', { type: 'hidden', name: 'properties[Languages]' }); box.appendChild(pLangs);

    var lastLang = null;
    function layout() {
      var st = current();
      rows.forEach(function (r, i) {
        r.wrap.hidden = i >= st.n;
        // name 1 follows the product's language choice; the others follow name 1 until changed
        if (i === 0) { if (st.lang !== lastLang) { lastLang = st.lang; if (r.sel.value !== st.lang) { r.sel.value = st.lang; newLang(r); refreshSuggest(r); } } }
        else if (i > 0 && !r.langTouched && r.sel.value !== rows[0].sel.value) { r.sel.value = rows[0].sel.value; newLang(r); refreshSuggest(r); }
      });
      rows.forEach(labels); sync();
    }

    /* ----- checks before add to cart ----- */
    form.addEventListener('submit', function (e) {
      var bad = null, st = current();
      rows.slice(0, st.n).forEach(function (r) { if (!bad && !r.en.value.trim()) bad = r; });
      if (bad) { e.preventDefault(); e.stopImmediatePropagation(); bad.en.classList.add('invalid'); bad.wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      else sync();
    }, true);
    forms.slice(1).forEach(function (f2) {
      f2.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); var b = form.querySelector('[type="submit"]'); if (b) b.click(); }, true);
    });

    /* ----- preview slide (same behaviour as the name previews) ----- */
    var pcss = el('style'); pcss.textContent = [
      '.jmnp{position:relative;background:#f2f2f2;border-radius:var(--media-radius,0);overflow:hidden}',
      '.jmnp canvas{display:block;width:100%;height:auto;aspect-ratio:1/1}',
      '.jmnp__cap{position:absolute;left:0;right:0;bottom:.6em;text-align:center;font-size:.78em;letter-spacing:.06em;opacity:.6;margin:0}',
      '.jmnp-thumb__btn{display:block;width:100%;padding:0;border:0;background:#f2f2f2;cursor:pointer}',
      '.jmnp-thumb__btn canvas{display:block;width:100%;height:auto;aspect-ratio:1/1}',
      '.jmnp-mini{position:fixed;right:12px;top:80px;z-index:30;padding:0;border:1px solid rgba(0,0,0,.12);border-radius:12px;background:#f2f2f2;box-shadow:0 6px 20px rgba(0,0,0,.18);overflow:hidden;cursor:pointer}',
      '.jmnp-mini[hidden]{display:none}',
      '.jmnp-mini canvas{display:block;width:100%;height:100%}',
      '.ymq-options-box{display:none!important}'
    ].join(''); document.head.appendChild(pcss);
    var host = document.querySelector('.product__media-wrapper');
    var list = host && host.querySelector('.product__media-list, [id^="Slider-Gallery"]');
    if (!list) return;
    var slide = el('li', 'product__media-item flex-grid__item slider__slide jmnp-slide', { 'data-jmnp-slide': '' });
    var shown = false, cv = el('canvas', '', { role: 'img', 'aria-label': 'Live preview of your necklace' }), pbox = el('div', 'jmnp');
    var cap = el('p', 'jmnp__cap'); cap.textContent = 'Live preview: updates as you type';
    pbox.appendChild(cv); pbox.appendChild(cap); slide.appendChild(pbox);
    var thumbs = host.querySelector('.thumbnail-list, [id^="Slider-Thumbnails"]'), thumb = null, tcv = null;
    if (thumbs) {
      thumb = el('li', 'thumbnail-list__item slider__slide jmnp-thumb');
      var tb = el('button', 'jmnp-thumb__btn', { type: 'button', 'aria-label': 'Show your design' }); tcv = el('canvas');
      tb.appendChild(tcv); thumb.appendChild(tb); tb.addEventListener('click', function () { userChose = false; activate(true); });
    }
    function placeIn(parent, node) { var f = parent.firstElementChild, v = f && f !== node && /--variant/.test(f.className); if ((v ? f.nextElementSibling : f) !== node) parent.insertBefore(node, v ? f.nextSibling : f); }
    var userAt = 0, activatedAt = 0, userChose = false;
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) { host.addEventListener(ev, function () { userAt = Date.now(); }, { capture: true, passive: true }); });
    function activate(smooth) {
      if (!shown) return;
      placeIn(list, slide); if (thumb && thumbs) placeIn(thumbs, thumb);
      Array.prototype.forEach.call(list.querySelectorAll('.is-active'), function (li) { if (li !== slide) li.classList.remove('is-active'); });
      slide.classList.add('is-active'); activatedAt = Date.now();
      if (thumbs) { Array.prototype.forEach.call(thumbs.querySelectorAll('[aria-current]'), function (n) { n.removeAttribute('aria-current'); }); if (thumb) thumb.firstChild.setAttribute('aria-current', 'true'); }
      list.scrollTo({ left: slide.offsetLeft - list.offsetLeft, behavior: smooth ? 'smooth' : 'instant' });
    }
    new MutationObserver(function () {
      if (!shown) return;
      if (!slide.isConnected) { var l = host.querySelector('.product__media-list, [id^="Slider-Gallery"]'); if (l) { list = l; placeIn(l, slide); } }
      if (thumb && !thumb.isConnected) { var t = host.querySelector('.thumbnail-list, [id^="Slider-Thumbnails"]'); if (t) { thumbs = t; placeIn(t, thumb); } }
      var other = list.querySelector('.product__media-item.is-active:not([data-jmnp-slide])');
      if (!other) return;
      if (Date.now() - userAt < 1500) { userChose = true; if (slide.classList.contains('is-active')) slide.classList.remove('is-active'); if (thumb && thumb.firstChild.hasAttribute('aria-current')) thumb.firstChild.removeAttribute('aria-current'); }
      else if (!userChose && Date.now() - activatedAt > 50) activate();
    }).observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    var root = C.filesRoot || '/cdn/shop/files/', imgs = {};
    function base(m) {
      var file = String(cfg.images || 'custom-language-{type}-blank-{metal}.jpg').replace('{type}', cfg.type || 'necklace').replace('{metal}', m);
      if (!imgs[file]) imgs[file] = new Promise(function (res, rej) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = rej; i.src = root + file; });
      return imgs[file];
    }
    function plates() {
      var st = current();
      return rows.slice(0, st.n).map(function (r) {
        var L = lang(r), text = L === 'English' ? (r.en.value.trim() || r.sc.value.trim()) : (r.sc.value.trim() || '');
        var sample = false;
        if (!text) { text = L === 'English' ? (r.en.value.trim() || R.info(L)[4]) : R.info(L)[4]; sample = L !== 'English' && !!r.en.value.trim(); }
        return { text: text, lang: L, sample: sample };
      });
    }
    var last = '', token = 0, timer = null, placed = null;
    function render() {
      var st = current(), pl = plates(), key = JSON.stringify(pl) + st.metal;
      if (key === last) return; last = key;
      var my = ++token;
      base(st.metal).then(function (img) {
        return R.draw(cv, img, cfg.chain || [], pl, st.metal, { w: cfg.w || 1500, letter: cfg.letter, weight: cfg.weight, slots: cfg.slots, widest: cfg.widest, hw: cfg.hw }).then(function (p) {
          if (my !== token) return; placed = p;
          cap.textContent = pl.some(function (q) { return q.sample; }) ? 'Sample word shown: we’ll translate your name before it’s made' : 'Live preview: updates as you type';
          var f = focus();
          if (tcv) { tcv.width = tcv.height = 240; tcv.getContext('2d').drawImage(cv, f.x, f.y, f.w, f.h, 0, 0, 240, 240 * f.h / f.w); }
          sizeMini(f);
          if (!shown) { shown = true; placeIn(list, slide); if (thumb && thumbs) placeIn(thumbs, thumb); if (!userAt) activate(); }
          placeMini();
        });
      }).catch(function () { if (my !== token) return; mini.hidden = true; });
    }
    // the area around the plates, for the thumbnail and the floating preview
    function focus() {
      var W = cv.width, H = cv.height;
      if (!placed || !placed.length) return { x: 0, y: 0, w: W, h: H };
      var x0 = 1e9, x1 = -1e9, y0 = 1e9, y1 = -1e9;
      placed.forEach(function (p) { var b = p.box || [p.a[0], p.a[1], p.b[0], p.b[1] + (p.hpx || 0)]; x0 = Math.min(x0, b[0]); y0 = Math.min(y0, b[1]); x1 = Math.max(x1, b[2]); y1 = Math.max(y1, b[3]); });
      var pad = 50 * W / (cfg.w || 1500), w = x1 - x0 + pad * 2, h = y1 - y0 + pad * 2;
      if (w / h > 2.2) h = w / 2.2; if (w / h < 1) w = h;
      var cx = (x0 + x1) / 2, cy = (y0 + y1) / 2;
      return { x: Math.max(0, Math.min(W - w, cx - w / 2)), y: Math.max(0, Math.min(H - h, cy - h / 2)), w: w, h: h };
    }
    var mini = el('button', 'jmnp-mini', { type: 'button', 'aria-label': 'Back to your design', hidden: '' }), mcv = el('canvas');
    mini.appendChild(mcv); document.body.appendChild(mini);
    mini.addEventListener('click', function () { userChose = false; activate(true); var r = host.getBoundingClientRect(); if (r.top < 0 || r.bottom > window.innerHeight) host.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    function sizeMini(f) {
      // grows with the names: about 0.42 screen px per preview px, from a small chip up to the screen width
      var k = 1500 / (cfg.w || 1500), bw = Math.round(Math.max(cfg.miniMin || 150, Math.min(window.innerWidth - 24, cfg.miniMax || 460, f.w * k * (cfg.miniScale || 0.42)))), bh = Math.round(bw * f.h / f.w);
      mini.style.width = bw + 'px'; mini.style.height = bh + 'px';
      mcv.width = bw * 2; mcv.height = bh * 2; mcv.getContext('2d').drawImage(cv, f.x, f.y, f.w, f.h, 0, 0, mcv.width, mcv.height);
    }
    function placeMini() {
      var vh = window.innerHeight, g = list.getBoundingClientRect(), fr = box.getBoundingClientRect();
      var galleryOn = Math.min(g.bottom, vh) - Math.max(g.top, 0) > Math.min(g.height, vh) * 0.35;
      var on = shown && !galleryOn && fr.bottom > 0 && fr.top < vh;
      if (on) { var hdr = document.querySelector('sticky-header, .header-wrapper, header'), b = 0; if (hdr) { var hr = hdr.getBoundingClientRect(); if (hr.bottom > 0 && hr.height < 200) b = hr.bottom; } mini.style.top = Math.max(8, b + 8) + 'px'; }
      if (mini.hidden === on) mini.hidden = !on;
    }
    window.addEventListener('scroll', placeMini, { passive: true });
    window.addEventListener('resize', placeMini);

    function soon() { clearTimeout(timer); timer = setTimeout(render, 120); userChose = false; if (shown && !slide.classList.contains('is-active')) activate(true); }
    var lastV = null;
    setInterval(function () { var v = (form.querySelector('[name="id"]') || {}).value; if (v !== lastV) { lastV = v; layout(); soon(); } render(); placeMini(); }, 400);
    layout(); render();
    window.JMLangPreview = { render: function () { last = ''; render(); }, rows: rows, plates: plates };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); }); else setTimeout(start, 0);
  window.addEventListener('load', start);
})();
